import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { HashMap, TranslocoService } from '@ngneat/transloco';
import { Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PageTitleService {

  private currentTitleKey: string;
  private currentParams: HashMap | undefined;
  private titleSubscription: Subscription;
  constructor(
    private titleService: Title,
    private translocoService: TranslocoService,
  ) {
  }

  setTitle(titleKey: string, params?: HashMap) {
    this.currentTitleKey = titleKey;
    this.currentParams = params;
    this.setCurrentTitle();
  }

  private setCurrentTitle() {
    if (this.titleSubscription) {
      this.titleSubscription.unsubscribe();
    }
    this.titleSubscription = this.translocoService.selectTranslate(this.currentTitleKey, this.currentParams)
      .subscribe({
        next: (value) => {
          this.titleService.setTitle(`${ value } - PVSmartClick`);
        },
      });
  }
}
